import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from "primeng/api";
import AOS from "aos";

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent  implements OnInit {
  menuItem: MenuItem[];

  constructor( private messageService: MessageService, private confirmationService: ConfirmationService
  ,@Inject(LOCALE_ID) public locale: string) { }
  ngOnInit(): void {
    // AOS.init();
    this.menuItem=[
      {label:$localize`:@@Login:Login`},
      {label:$localize`:@@Documentation:Documentation`}
    ]
  }


  changLanguage(langu: string) {
    var pathname = document.location.href.replace(this.locale,langu);
    window.location.replace(pathname);
  }
}
